<template>
  <div>
    <header>
      单位名称：
      <el-input
        v-model="searchKey"
        placeholder="请输入单位名称"
        style="width: 340px"
      ></el-input>状态：
      <el-select
        v-model="status"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          value="-1"
        ></el-option>
        <el-option
          label="有效"
          value="1"
        ></el-option>
        <el-option
          label="无效"
          value="2"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="getList()"
      >查询</el-button>
      <el-button
        type="primary"
        @click="openAdd"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        type="index"
        label="序号"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="分公司名称"
        width="180"
      ></el-table-column>

      <el-table-column
        prop="usedProjectCount"
        label="已使用项目数量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="projectCount"
        label="最大授权项目数量"
        align="center"
      ></el-table-column>
      <el-table-column
        label="授权模块"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getModules(scope.row)"
          >配置模块</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="receiveMoneyType"
        label="收款形式"
        align="center"
      >
      </el-table-column>-->

      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.status == 1 ? '有效' : '无效' }}</template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top: 20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>

    <el-dialog
      :title="editId ? '编辑' : '新增'"
      :visible.sync="addDialogVisible"
      width="1300px"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
      @close="dialogCloseFun"
    >
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="160px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="分公司名称:"
              prop="companyName"
            >
              <el-input v-model="form.companyName" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item
              label="公司名称:"
              prop="companyName"
            >
              <el-select
                v-model="form.companyName"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                > </el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item
              label="公司地址:"
              prop="address"
            >
              <el-cascader
                size="large"
                :options="options"
                v-model="form.selectedOptions"
              ></el-cascader>
              <el-input
                style="width: 222px; margin-left: 10px"
                v-model="form.address"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="统一社会信用代码:"
              prop="unitCode"
            >
              <el-input v-model="form.unitCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="公司法人:"
              prop="companyLeader"
            >
              <el-input v-model="form.companyLeader"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="账号:"
              prop="userAccount"
            >
              <el-input v-model="form.userAccount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="密码:"
              prop="userPwd"
            >
              <el-input
                v-model="form.userPwd"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="最大授权项目数:"
              prop="projectCount"
            >
              <el-input
                v-model="form.projectCount"
                type="number"
                onkeyup="value=value.replace(/[^0-9]/g,'');if(value>100){value=100};if(String(value)==='0'){value=1}"
                placeholder="最大数量100"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="有效状态:"
              prop="status"
            >
              <el-radio
                v-model="form.status"
                :label="1"
              >有效</el-radio>
              <el-radio
                v-model="form.status"
                :label="2"
              >无效</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号码:"
              prop="telephone"
            >
              <el-input v-model="form.telephone"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-form-item>
          <el-button
            type="primary"
            :disabled="addClickCount"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- <authorization
      :isShow="authorizationShow"
      @isShow="closeAuthor"
    />-->
    <funAuthorization
      ref="funAuthorization"
      @submitHandle="selectModules"
    ></funAuthorization>

  </div>
</template>

<script>
import {
  regionData
} from "element-china-area-data";
import funAuthorization from "@/components/funAuthorization.vue";


import {
  Api_Company,
  Api_SuperAdmin
} from "@/api/api";

import { getStore } from '@/util/store'
import mixin_dialog from '@/mixins/dialog.js';

export default {
  components: {
    funAuthorization
  },
  mixins: [mixin_dialog],
  data() {
    return {
      options: regionData,
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      selectedOptions: [],
      searchKey: "",
      status: "-1",
      authorizationShow: false,
      tableData: [],
      addDialogVisible: false,
      form: {
        status: 1
      },
      rules: {
        companyName: [{
          required: true,
          message: "请输入分公司名称",
          trigger: "blur",
        },],
        address: [{
          required: true,
          message: "请输入地址",
          trigger: "blur",
        },],
        unitCode: [{
          required: true,
          message: "请输入统一社会信用代码",
          trigger: "blur",
        },],
        companyLeader: [{
          required: true,
          message: "请输入公司法人",
          trigger: "blur",
        },],
        projectCount: [
          {
            required: true,
            message: "请输入项目最大授权数",
            trigger: "blur",
          },
        ],
        status: [{
          required: true,
          message: "请选择状态",
          trigger: "blur",
        },],
        userAccount: [{
          required: true,
          message: "请输入用户账户",
          trigger: "blur",
        },],
        userPwd: [{
          required: true,
          message: "请输入用户密码",
          trigger: "blur",
        },],
        telephone: [
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      haveID: '',
      companyId: '',
      itemId: '',
      propsKey: [],
      companyList: [{
        label: '请选择',
        value: -1
      }],
      addClickCount: false, // 添加按钮点击次数
      editId: 0,
      leaderOptions: [
        {
          value: 0,
          label: "重庆"
        }
      ]
    };
  },
  created() {
    this.getList();
    // this.getCompanyList()
  },
  methods: {
    onLeaderChange(val) {
      console.log(val);
    },
    openAdd() {
      this.addDialogVisible = true
      this.addClickCount = false
      this.form = {
        status: 1
      }
    },
    getCompanyList() {
      this.companyList = [{
        label: '请选择',
        value: -1
      }]
      Api_SuperAdmin.allList().then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          result.data.map(item => {
            this.companyList.push({
              label: item.companyName,
              value: item.id
            })
          })
        }
      })
    },
    // 获取公司所有菜单
    getModules(val) {
      console.log(val, "vallll");
      this.companyId = val.parentId;
      this.itemId = val.id
      Api_SuperAdmin.modulesSubDetail(this.companyId).then(res => {
        if (res.data.data && res.data.data.authorityMenuId) {
          this.getMenuSelect(val.id)
        }
      })
    },
    getMenuSelect(id) {
      const that = this
      Api_SuperAdmin.modulesDetail(id).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.propsKey = (result.data && result.data.authorityMenuId && result.data.authorityMenuId.split(',')) || []

          this.$refs.funAuthorization.open(1, this.propsKey)
          // this.authorizationShow = true;
        } else {
          this.propsKey = []
          this.$showMessage("失败", result.errors);
        }
      })
    },
    selectModules(modules) {
      Api_Company.setMenuModules({
        companyId: this.itemId,
        // authorityProjectId: this.projectId,
        menuIds: modules.join(',')
      }).then(res => {
        this.$message({
          type: "success",
          message: "设置成功!",
        });
        this.authorizationShow = false
      })
    },
    submitForm(formName) {
      console.log(this.form);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.add();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.addDialogVisible = false;
      this.form = {};
      this.editId = 0;
    },
    edit(item) {
      this.editId = item.id
      Api_Company.detail(item.id).then((res) => {
        item = res.data.data;
        item.selectedOptions = [
          item.provinceId + "",
          item.cityId + "",
          item.areaId + "",
        ];
        this.form = item;
        this.addDialogVisible = true;
      });
    },
    del(item) {
      this.$confirm("是否删除此公司?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api_Company.del(item.id).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        });
      });
    },
    add() {
      this.addClickCount = true
      this.form.provinceId = this.form.selectedOptions[0];
      this.form.cityId = this.form.selectedOptions[1];
      this.form.areaId = this.form.selectedOptions[2];

      if (this.form.id) {
        Api_Company.editUpdate(this.form).then((res) => {
          this.addClickCount = false
          if (res.data.data) {
            this.$message({
              type: "success",
              message: "更新成功!",
            });
            this.addDialogVisible = false;
            this.form = {};
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.data.errors,
            });
          }
        }).catch(res => {
          this.addClickCount = false
        });
      } else {
        // this.form.id = 0;
        this.form.parentId = getStore({ name: 'companyId' });
        Api_Company.add(this.form).then((res) => {
          this.addClickCount = false
          if (res.data.data) {
            this.$message({
              type: "success",
              message: "添加成功!",
            });
            this.addDialogVisible = false;
            this.form = {};
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.data.errors,
            });
          }
        }).catch(res => {
          this.addClickCount = false
        });
      }
    },
    getList() {
      Api_Company.list({
        pageSize: this.pagesize,
        pageIndex: this.currentPage,
        companyName: this.searchKey,
        companyId: getStore({ name: 'companyId' }),
        status: this.status,
      }).then((res) => {
        const { data: result } = res;
        if (result.statusCode == 200) {
          this.tableData = res.data.data.tList;
          this.totalCount = res.data.data.totalCount;
        }
      });
    },
    handleClose() {
      this.addDialogVisible = false;
    },
    closeAuthor(val) {
      this.authorizationShow = val;
      this.propsKey = []
      this.haveID = ''
      this.companyId = ''
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>